module.exports = __webpack_public_path__ + "img/housing.d5f78cc0.svg";